export const tr = {
    'common-error-update-regions': 'Gösterim bölgesi güncellenirken hata oluştu',
    'link-message-groups': 'Görüntüle'
};
